module.exports = __webpack_public_path__ + "img/img-23.9c9d562a.webp";